import Svg, { Path } from '@rd-core-svg/svg'
import { useTheme } from '~/hooks/use-theme'
import type { SvgProps } from '@rd-core-svg/svg'

export const ArrowSvg = ({ width, height, ...rest }: SvgProps) => {
  const theme = useTheme()

  const svgWidth = width ?? theme.sizingTiny
  const svgHeight = height ?? theme.sizingMicro

  return (
    <Svg
      width={svgWidth}
      height={svgHeight}
      viewBox={`0 0 ${svgWidth} ${svgHeight}`}
      fill="none"
      {...rest}
    >
      <Path
        d="M7.58579 7.58579L0 0H18L10.4142 7.58579C9.63317 8.36684 8.36684 8.36684 7.58579 7.58579Z"
        fill={theme.colorFillNeutralDefault}
      />
      <Path
        d="M0.5 0.5H0.970581L7.58579 7.09097C8.36726 7.86958 9.63159 7.86841 10.4116 7.08838L17 0.5H17.4706"
        stroke={theme.colorBorderNeutralDefault}
        strokeLinecap="square"
      />
    </Svg>
  )
}
